import { AspectRatio, Box, Center, VStack, useTheme } from "@chakra-ui/react";
import ActionButton from "@modules/Layout/components/ActionButton";
import React from "react";
import { Else, If, Then } from "react-if";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { Banner } from "@types/common";
import { IImageFluidItem } from "../models/fluidImage";
import { BannerFluidImageHero } from "../style";
import FluidImage from "./FluidImage";
import LinkBreadcrumb from "./LinkBreadcrumb";
import ResponsiveContainer from "./ResponsiveContainer";
interface Props {
  data: Banner;
  contentWidth?: "xs" | "md" | "lg" | "xl" | "2xl" | "full";
  coverBorder?: "xs" | "md" | "lg" | "xl" | "2xl" | "none";
  typeImage?: "cover" | "crop" | null;
}

const CropImage = ({ dataCover }: { dataCover: IImageFluidItem }) => {
  return (
    <AspectRatio ratio={1} w="100%" h="100%">
      <FluidImage imageItem={dataCover} heightFluidImage={"100%"} />
    </AspectRatio>
  );
};

const CoverImage = ({ dataCover }: { dataCover: IImageFluidItem }) => {
  return <FluidImage imageItem={dataCover} />;
};

const BannerCropFluidImage: React.FC<Props> = ({
  data,
  typeImage = "crop",
}) => {
  if (!data) {
    return null;
  }
  const theme = useTheme();

  const maxW = { base: theme.breakpoints.customLg, xl: theme.breakpoints.xl };

  const breadcrumb = data.breadcrumb;
  const coverImage = data.cover;
  const hasMedia = coverImage?.url;

  const LoadImage = typeImage === "crop" ? CropImage : CoverImage;

  return (
    <BannerFluidImageHero>
      <If condition={!hasMedia && !data.content}>
        <Then>
          <ResponsiveContainer>
            <Box
              py={{ base: 5, md: 10 }}
              zIndex={1}
              display={{ base: "none", md: "block" }}
            >
              <LinkBreadcrumb links={breadcrumb} />
            </Box>
          </ResponsiveContainer>
        </Then>
        <Else>
          <Box position="relative" pt={!hasMedia ? 5 : 0}>
            <If condition={hasMedia}>
              <Then>
                <If condition={breadcrumb?.length > 0}>
                  <Then>
                    <Box
                      maxW={maxW}
                      w={"full"}
                      marginX={"auto"}
                      display={{ base: "none", md: "block" }}
                      position={{ base: "static", md: "absolute" }}
                      top={{ base: "auto", md: "0%" }}
                      left={{ base: "auto", md: "50%" }}
                      transform={{ base: "none", md: "translate(-50%, -50%)" }}
                      pt={{ base: 5, md: 0 }}
                      mt={{ base: 0, md: 5 }}
                      zIndex={1}
                    >
                      <Box px={{ base: 4, md: 7, lg: 12 }}>
                        <LinkBreadcrumb links={breadcrumb} />
                      </Box>
                    </Box>
                  </Then>
                </If>

                <Box
                  maxW={maxW}
                  w="full"
                  position={{ base: "static", md: "absolute" }}
                  top={{ base: "auto", md: "50%" }}
                  left={{ base: "auto", md: "50%" }}
                  transform={{ base: "none", md: "translate(-50%, -50%)" }}
                  pb={{ base: 10, md: 0 }}
                  pt={{ base: 5, md: 0 }}
                  zIndex={0}
                >
                  <Box
                    w={{
                      base: "100%",
                      md: "50%",
                    }}
                    mt={
                      breadcrumb?.length > 0
                        ? { base: 0, md: "8%", lg: "5%" }
                        : 0
                    }
                  >
                    <VStack
                      alignItems="start"
                      justifyContent="center"
                      my={!!hasMedia ? "0" : 5}
                      px={{ base: 4, md: 7, lg: 12 }}
                    >
                      <ReactMarkdown
                        children={data.content.data.content || ""}
                      />

                      <ActionButton actions={data.action} />
                    </VStack>
                  </Box>
                </Box>
                <Center
                  bg="transparent"
                  h={{
                    base: "16rem",
                    md: "22rem",
                    lg: "24rem",
                  }}
                  w={{
                    base: "100%",
                    md: "50%",
                  }}
                  color="white"
                  overflow={"hidden"}
                  marginLeft={{ base: 0, md: "50%" }}
                >
                  <LoadImage dataCover={data.cover} />
                </Center>
              </Then>
              <Else>
                <ResponsiveContainer>
                  <Box
                    maxW={maxW}
                    w={"full"}
                    pt={{ base: 5, md: 0 }}
                    zIndex={1}
                  >
                    <Box display={{ base: "none", md: "block" }}>
                      <LinkBreadcrumb links={breadcrumb} />
                    </Box>

                    <Box
                      w={{
                        base: "100%",
                        md: "50%",
                      }}
                      mt={7}
                    >
                      <VStack alignItems="start" justifyContent="center">
                        <ReactMarkdown
                          children={data.content.data.content || ""}
                        />

                        <ActionButton actions={data.action} />
                      </VStack>
                    </Box>
                  </Box>
                </ResponsiveContainer>
              </Else>
            </If>
          </Box>
        </Else>
      </If>
    </BannerFluidImageHero>
  );
};

export default BannerCropFluidImage;
